var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("\n    Oops we couldn't find that page. Try going\n    "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }